// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"38166158","382":"31d6cfe0","674":"b35d3d1b","789":"dbcc62ef","970":"38166158","984":"e52ef17b"}[chunkId] + ".chunk.css";
};